<ng-container>
    <div>
        <div style="margin-left: 78%; margin-top: 2%; margin-bottom: 2%;">

            <!-- <button class="noPrint same-btn mr-2" mat-raised-button color="primary"
                printSectionId="print-section" ngxPrint [useExistingCss]="true"> Print </button> -->

            <button class="noPrint same-btn mr-2" style="background-color: blue;color: white;"
                printSectionId="print-section" ngxPrint [useExistingCss]="true">Print</button>

            <button class="same-btn" mat-dialog-close onclick="closeexp()"
                style="background-color: red;color: white;">Close</button>
        </div>
    </div>
    <div class=" container" id="print-section">

        <div class="header-section">
            <div class="row heading-row"
                style="background-color: cadetblue; color: black;padding: 10px;margin-left: 4px;margin-right: 4px;">
                <div class="col-left">
                    <div><strong>दिनांक : {{ today | date:'dd-MM-yyyy' }}</strong> </div>
                    <div><strong></strong> </div><br>
                    <div><strong>पृष्ठ क्र. : १</strong></div>
                </div>
                <div class="col-center">
                    <div><strong>हिंदुस्थान प्रकाशन संस्था</strong></div>
                    <div><strong>विवेक साप्ताहिक</strong></div>
                    <div><strong>वर्गणीदार नोंदणी / नुतनीकरण महिन्याप्रमाणे यादी</strong></div>
                </div>
                <div class="col-right">
                    <div><strong>वर्गणी भरणारे</strong></div>
                    <div><strong></strong></div><br>
                    <div><strong>{{ startDate | date:'dd-MM-yyyy' }} ते {{ endDate | date:'dd-MM-yyyy' }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <div class="loader-overlay" *ngIf="loading">
            <span class="loader"></span>
            <div class="loader-text">Loading, please wait...</div>
        </div>

        <div class="header-section mx-5" *ngFor="let group of groupedTypes; let i = index">
            <table class="table table-bordered text-center custom-table" style="width: 100%;">
                <thead>
                    <tr style="font-weight: bold; background-color: skyblue; color: black;">
                        <th *ngIf="i === 0" rowspan="2">महिना आणि वर्ष</th>
                        <th *ngIf="i === 0" rowspan="2">एकूण जमा रक्कम</th>
                        <ng-container *ngFor="let type of group">
                            <th colspan="2">{{ type }}</th>
                        </ng-container>
                    </tr>
                    <tr style="font-weight: bold; background-color: skyblue; color: black;">
                        <ng-container *ngFor="let type of group">
                            <th>जमा रक्कम</th>
                            <th>पुढील वर्षासाठी</th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let month of months">
                        <td *ngIf="i === 0">{{ month }}</td>
                        <td *ngIf="i === 0">{{ getAllAmt(month).toFixed(2) }}</td>
                        <ng-container *ngFor="let type of group">
                            <td>{{ getAmount(month, type).toFixed(2) }}</td>
                            <td>{{ getNextCarryAmount(month, type).toFixed(2) }}</td>
                        </ng-container>
                    </tr>
                    <tr style="font-weight: bold; background-color: red; color: white;">
                        <td *ngIf="i === 0">एकूण</td>
                        <td *ngIf="i === 0">{{ getTotalAllAmt().toFixed(2) }}</td>
                        <ng-container *ngFor="let type of group">
                            <td>{{ getTotalAmount(type).toFixed(2) }}</td>
                            <td>{{ getTotalNextCarryAmount(type).toFixed(2) }}</td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
            <br>
        </div>

    </div>

</ng-container>